import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { Plus16 } from '@makyoapp/makyo-icon/icon'
import { Button } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'

import DialogListItem from './DialogListItem'

/**
 * DialogPanelNormal is a function component that renders a list of dialogs and a button to add a new dialog.
 *
 */
function DialogPanelNormal() {
  const { dialogs, addDialog, isDialogLoading } = useAppBuilderContext()

  return (
    <div className='p-4'>
      <div className={clsx('dialog-list flex flex-col pb-4')}>
        <div className='uppercase py-2'>
          <Trans>Dialogs</Trans>
        </div>
        <div className='flex flex-col gap-1'>
          {dialogs?.map((dialog) => {
            return <DialogListItem dialog={dialog} key={dialog.id} />
          })}
        </div>
      </div>

      <Button
        disabled={isDialogLoading}
        icon={isDialogLoading ? undefined : <Plus16 />}
        onClick={async () => {
          await addDialog()
        }}
        className='w-full'
      >
        {isDialogLoading ? <span className='loading spin' /> : <Trans>New Dialog</Trans>}
      </Button>
    </div>
  )
}

export default DialogPanelNormal
